<script setup lang="ts">
import BuyButtonComponent from '@/components/shared/BuyButtonComponent.vue'
import CountdownTileComponent from '@/components/shared/CountdownTileComponent.vue'

const props = defineProps<Props>()
const { triggerApi } = gamesUtils
const { nextLoopEvent } = utilsPlugin

const { isLogged } = gamesUtils
const { t } = useI18n()
interface Props {
  free: Array<Games.Offer>
  showRemember?: boolean
}
const freeOfferRendered = computed<Array<Games.Offer>>(() => {
  if (props.free.length) {
    const offers = [...props.free]
    offers.forEach((offer) => {
      if ((offer?.expireSec || 0) <= 0) {
        offer.expireSec = offer.expireSec || 0
      }
      if ((offer?.expireSec || 0) >= 86_400 /* 24 * 60 * 60 */) {
        offer.expireSec = 0
      }
      offer.expireSec = (offer?.expireSec || 0)
    })
    return offers
  }
  return []
})
const activeTimer = ref(true)
function onEndCounter() {
  activeTimer.value = false
  nextLoopEvent().then(() => {
    activeTimer.value = true
    triggerApi.callTrigger()
  })
}
</script>

<template>
  <div
    v-if="isLogged && free.length"
    class="px-2 big:px-4 flex flex-col gap-4 justify-center"
    :class="{
      'gap-4 pt-3': showRemember,
      'gap-8 py-3': !showRemember
    }"
  >
    <template
      v-for="freeOffer in freeOfferRendered"
      :key="freeOffer.id"
    >
      <div
        v-if="freeOffer.isFree && freeOffer?.items?.[0]"
        class="flex flex-col justify-center items-center big:px-4 w-full"
      >
        <div
          class="rounded-xl bg-[#032744] text-white w-full max-w-md big:max-w-xl bg-cover bg-no-repeat bg-top grid grid-cols-[min(18%,120px)_minmax(0,1fr)_auto] gap-x-2 py-4 pl-3 pr-4 mini:pl-5 mini:pr-8 sm:pl-7 sm:pr-12  items-center relative "
          :style="{ backgroundImage: `url('${freeOffer.asset}')` }"
        >
          <CountdownTileComponent
            v-if="freeOffer.isBought && activeTimer && (freeOffer.expireSec ?? 0) > 0"
            :offer="freeOffer"
            class="top-0 right-4 mini:right-8 sm:right-12 w-24 mini:min-w-28 -translate-y-1/2 "
            :force-visibility="freeOffer.isBought"
            @end="onEndCounter"
          />
          <div class="relative mb-3">
            <img
              :src="freeOffer.items[0].asset"
              :alt="freeOffer.items[0].label || freeOffer.items[0].title"
              class="w-full object-contain max-h-16"
            >
            <div class="gs-text-shadow font-black text-white text-center absolute -bottom-2 left-0 right-0 leading-none text-[1.6rem]">
              +{{ freeOffer.items[0]._amountShort }}
            </div>
          </div>
          <div class="font-black min-w-0">
            <div class="uppercase text-[1.35rem] mini:text-2xl leading-[1.1em] mini:leading-[1.1em] big:pb-0">
              {{ t('freeItem.daily') }}
              <br>
              <span class="text-[#ffb401] hyphens-auto"> {{ t('freeItem.free') }} </span>
            </div>
          </div>
          <div class="">
            <BuyButtonComponent
              class="inline-block w-24 mini:w-28 "
              :offer="freeOffer"
              mini
            >
              <template #text>
                <span class="text-lg tracking-wide uppercase">{{ freeOffer?.isBought ? t('freeItem.claimed') : t('freeItem.claim') }}</span>
              </template>
            </BuyButtonComponent>
          </div>
        </div>
        <div
          v-if="showRemember"
          class="text-base big:text-lg text-neutral-500 font-semibold mt-1.5 text-center"
        >
          {{ t('freeItem.rememberPre') }} <span class="uppercase">{{ t('freeItem.free') }} {{ freeOffer.items[0].label || freeOffer.items[0].title }}</span> {{ t('freeItem.rememberPost') }}
        </div>
      </div>
    </template>
  </div>
</template>

<style scoped lang="postcss"></style>
